webpackJsonp([154690009208739],{

/***/ 777:
/***/ (function(module, exports) {

	module.exports = {
	  "key": "linters",
	  "name": "Linters",
	  "description": "Linters find potential errors and/or formatting inconsistencies in your code. Some will automatically fix your code for you.",
	  "aka": [
	    "code formatters",
	    "beautifiers",
	    "prettifiers"
	  ],
	  "tags": [
	    {
	      "name": "html",
	      "description": "Formats/beautifies HTML."
	    },
	    {
	      "name": "css",
	      "description": "Formats/beautifies CSS."
	    },
	    {
	      "name": "js",
	      "description": "Formats/beautifies JavaScript."
	    },
	    {
	      "name": "opinionated",
	      "description": "These don't need configuration because they take a stance on every rule."
	    },
	    {
	      "name": "english",
	      "description": "These lint english - not a programming language."
	    },
	    {
	      "name": "autofix",
	      "description": "These linters will automatically fix your code for you."
	    },
	    {
	      "name": "eslint",
	      "description": "These linters are powered by ESLint"
	    },
	    {
	      "name": "typescript",
	      "description": "Linter for TypeScript"
	    }
	  ],
	  "articles": [],
	  "projects": [
	    {
	      "githubPath": "palantir/tslint",
	      "description": ":vertical_traffic_light: An extensible linter for the TypeScript language",
	      "homepage": "http://palantir.github.io/tslint/",
	      "dependencies": null,
	      "tags": [
	        "typescript"
	      ],
	      "lastStarCount": 3672,
	      "lastUpdatedAt": "2018-07-27T20:30:22Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/303157?v=4"
	    },
	    {
	      "githubPath": "beautify-web/js-beautify",
	      "description": "Beautifier for javascript ",
	      "homepage": "https://beautifier.io",
	      "dependencies": null,
	      "tags": [
	        "js",
	        "html",
	        "autofix"
	      ],
	      "lastStarCount": 5582,
	      "lastUpdatedAt": "2018-07-26T23:03:20Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/6538164?v=4"
	    },
	    {
	      "githubPath": "prettier/prettier",
	      "description": "Prettier is an opinionated code formatter.",
	      "homepage": "https://prettier.io",
	      "dependencies": null,
	      "tags": [
	        "js",
	        "css",
	        "autofix"
	      ],
	      "lastStarCount": 26318,
	      "lastUpdatedAt": "2018-07-27T21:13:49Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/25822731?v=4"
	    },
	    {
	      "githubPath": "CSSLint/csslint",
	      "description": "Automated linting of Cascading Stylesheets",
	      "homepage": "http://csslint.net",
	      "dependencies": null,
	      "tags": [
	        "css"
	      ],
	      "lastStarCount": 4283,
	      "lastUpdatedAt": "2018-07-27T06:01:29Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/7219403?v=4"
	    },
	    {
	      "githubPath": "csscomb/csscomb.js",
	      "description": "CSS coding style formatter",
	      "homepage": "http://csscomb.com/",
	      "dependencies": null,
	      "tags": [
	        "css"
	      ],
	      "lastStarCount": 2655,
	      "lastUpdatedAt": "2018-07-27T06:01:37Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1645795?v=4"
	    },
	    {
	      "githubPath": "standard/standard",
	      "description": "🌟 JavaScript Style Guide, with linter & automatic code fixer",
	      "homepage": "https://standardjs.com",
	      "dependencies": null,
	      "tags": [
	        "js",
	        "opinionated",
	        "eslint",
	        "autofix"
	      ],
	      "lastStarCount": 18665,
	      "lastUpdatedAt": "2018-07-27T18:07:08Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/29208316?v=4"
	    },
	    {
	      "githubPath": "douglascrockford/JSLint",
	      "description": "The JavaScript Code Quality Tool",
	      "homepage": "http://JSLint.com/",
	      "dependencies": null,
	      "tags": [
	        "js"
	      ],
	      "lastStarCount": 3184,
	      "lastUpdatedAt": "2018-07-24T17:02:52Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/262641?v=4"
	    },
	    {
	      "githubPath": "eslint/eslint",
	      "description": "A fully pluggable tool for identifying and reporting on patterns in JavaScript",
	      "homepage": "https://eslint.org",
	      "dependencies": null,
	      "tags": [
	        "js",
	        "eslint",
	        "autofix"
	      ],
	      "lastStarCount": 11968,
	      "lastUpdatedAt": "2018-07-27T21:13:09Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/6019716?v=4"
	    },
	    {
	      "githubPath": "jshint/jshint",
	      "description": "JSHint is a tool that helps to detect errors and potential problems in your JavaScript code",
	      "homepage": "http://jshint.com",
	      "dependencies": null,
	      "tags": [
	        "js"
	      ],
	      "lastStarCount": 7976,
	      "lastUpdatedAt": "2018-07-27T19:00:05Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1335450?v=4"
	    },
	    {
	      "githubPath": "stylelint/stylelint",
	      "description": "A mighty, modern style linter",
	      "homepage": "https://stylelint.io/",
	      "dependencies": null,
	      "tags": [
	        "css"
	      ],
	      "lastStarCount": 5181,
	      "lastUpdatedAt": "2018-07-27T14:26:52Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/10076935?v=4"
	    },
	    {
	      "githubPath": "btford/write-good",
	      "description": "Naive linter for English prose",
	      "homepage": null,
	      "dependencies": null,
	      "tags": [
	        "english"
	      ],
	      "lastStarCount": 3399,
	      "lastUpdatedAt": "2018-07-26T02:11:45Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/474988?v=4"
	    },
	    {
	      "githubPath": "xojs/xo",
	      "description": "❤️ JavaScript happiness style linter",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [
	        "js",
	        "opinionated",
	        "eslint",
	        "autofix"
	      ],
	      "lastStarCount": 3903,
	      "lastUpdatedAt": "2018-07-27T20:58:38Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/12815325?v=4"
	    },
	    {
	      "githubPath": "wooorm/alex",
	      "description": "Catch insensitive, inconsiderate writing",
	      "homepage": "http://alexjs.com",
	      "dependencies": null,
	      "tags": [
	        "english"
	      ],
	      "lastStarCount": 2324,
	      "lastUpdatedAt": "2018-07-26T15:52:06Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/944406?v=4"
	    }
	  ]
	}

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _linters = __webpack_require__(777);
	
	var _linters2 = _interopRequireDefault(_linters);
	
	var _Page = __webpack_require__(10);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ListPageContainer = __webpack_require__(18);
	
	var _ListPageContainer2 = _interopRequireDefault(_ListPageContainer);
	
	var _StyledTextBlock = __webpack_require__(15);
	
	var _StyledTextBlock2 = _interopRequireDefault(_StyledTextBlock);
	
	var _addNotes = __webpack_require__(43);
	
	var _addNotes2 = _interopRequireDefault(_addNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extendedList = (0, _addNotes2.default)(_linters2.default, {
	  "prettier/prettier": "Using prettier really increases the readability of your code by automatically keeping your code wrapped to a reasonable line-length. Great when combined with another linter like ESLint to catch potential errors."
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(
	      _ListPageContainer2.default,
	      { list: extendedList },
	      _react2.default.createElement(
	        _StyledTextBlock2.default,
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Linters find potential errors and/or formatting inconsistencies in your code."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Some will ",
	          _react2.default.createElement(
	            "a",
	            { href: "#tag:autofix" },
	            "automatically fix"
	          ),
	          " your code for you. Most are configurable, but others are",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "#tag:opinionated" },
	            "opinionated"
	          ),
	          " (meaning you must subscribe to the given rules without changing anything)."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-list-linters-js-97f8af765dba55a4a3af.js